import { Company } from "domain-entities";

interface Props {
	userId?: string;
	company?: Company;
}

export const getMemberRole = (props: Props) => {
	const { userId, company } = props;

	return Object.values(company?.members || {}).find(
		(member) => member.id === userId
	)?.role;
};
